import { render, staticRenderFns } from "./mycard.vue?vue&type=template&id=6cfba79f&scoped=true&"
import script from "./mycard.vue?vue&type=script&lang=js&"
export * from "./mycard.vue?vue&type=script&lang=js&"
import style0 from "./mycard.vue?vue&type=style&index=0&id=6cfba79f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfba79f",
  null
  
)

export default component.exports